type FieldDef = {
  key: string;
  label: string;
  placeholder?: string;
  type?: "text" | "email" | "tel";
  autoComplete?: string;
};

type DetailsFormStepProps = {
  title: string;
  description?: string;
  fields: FieldDef[];
  values: Record<string, any>;
  onChange: (key: string, value: string) => void;
  errors?: Record<string, string>;
};

export function DetailsFormStep({
  title,
  description,
  fields,
  values,
  onChange,
  errors,
}: DetailsFormStepProps) {
  return (
    <section className="space-y-4">
      <header className="space-y-1">
        <h2 className="text-xl font-bold text-[var(--text-primary)]">{title}</h2>
        {description && <p className="text-sm text-[var(--text-muted)]">{description}</p>}
      </header>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {fields.map((field) => (
          <label key={field.key} className="space-y-1">
            <span className="text-xs font-semibold uppercase tracking-wide text-[var(--text-muted)]">
              {field.label}
            </span>
            <input
              type={field.type ?? "text"}
              inputMode={field.type === "tel" ? "tel" : field.type === "email" ? "email" : "text"}
              autoComplete={field.autoComplete}
              value={String(values[field.key] ?? "")}
              onChange={(event) => onChange(field.key, event.target.value)}
              placeholder={field.placeholder ?? field.label}
              className="
                w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2.5 text-sm
                text-[var(--text-primary)] shadow-sm transition
                focus:outline-none focus:ring-2 focus:ring-[var(--brand)]
              "
            />
            {errors?.[field.key] && (
              <p className="text-xs font-medium text-red-600">{errors[field.key]}</p>
            )}
          </label>
        ))}
      </div>
    </section>
  );
}
